// extracted by mini-css-extract-plugin
export var orderSummary = "_o1-0";
export var showMoreLessButton = "_o1-1";